module.exports = __webpack_public_path__ + "0908f6b7f46376595e93421cf5a4c930.png";